import {ControllerBase} from "../../../controllerBase";
import {listaCepController} from "./listaCepController";
import global from 'globalMU'


declare var window:any
declare var AsideDireita:any
const ko = require('knockout')

export const enderecoController = ControllerBase.extend({
    tamanhoPagina: 20,

    obterEnderecoPorCep: function (cep, callback) {

        global.ajax({
            url: "/Comum/ObterEnderecoPorCep",
            type: "post",
            data: {
                cep: cep
            },
            success: function(data) {
                if (!data || data.Error) {
                    return;
                }
                if (callback) {
                    callback(data);
                }
            }
        });

    },

    obterCepPorEndereco: function (model, pagina, definirCepCallback, atualizarModelCallback) {

        if (!model && this.model) {
            model = this.model;
        }
        this.model = model;
        var self = this;

        var filtros = ko.mapping.toJS(model);
        filtros.Logradouro =
            filtros.Logradouro && filtros.Logradouro != ""
            ? filtros.Logradouro
            : filtros.Endereco && filtros.Endereco != ""
            ? filtros.Endereco
            : "";
        filtros.Logradouro = filtros.Logradouro == null ? "" : filtros.Logradouro;
        filtros.SiglaUf = filtros.CodigoEstado && filtros.CodigoEstado > 7 ? filtros.SiglaUf : "";
        filtros.NomeCidade = filtros.CodigoCidade && filtros.CodigoCidade > 7 ? filtros.NomeCidade : "";
        filtros.NumeroPagina = pagina || 1;
        filtros.TamanhoPagina = this.tamanhoPagina;

        global.ajax({
            url: "/Comum/ObterCepPorEndereco",
            type: "post",
            data: {
                pesquisaCEP: filtros
            },
            success: function (data) {
                if (!data || data.Error) {
                    return;
                }
                if (definirCepCallback) {
                    if (data.Entities.length == 1) {
                        definirCepCallback(data.Entities[0].Cep.trim());
                    }
                    else {
                        self.mostrarListaCep(data, definirCepCallback);
                    }
                }
                if (atualizarModelCallback) {
                    atualizarModelCallback(data);
                }

            }
        });

    },

    mostrarListaCep: function (data, callback) {
        this.ListaCepController = this.showView({
            region: {
                name: "ListaCepController",
                selector: "#lista-cep-region"
            },
            modal: true,
            controller: {
                type: listaCepController,
                args: {
                    data: data,
                    callback: callback,
                    pesquisar: $.proxy(this.obterCepPorEndereco, this)
                }
            }
        });
    }
});

window.enderecoController = enderecoController
